import React, { FC } from "react";

const ErrorLine = ({ errorText, type }) => {
    let clr = "green";
    if (type == "warning") {
        clr = "orange";
    }
    else if (type == "error") {
        clr = "red";
    }
    return (
        <div
            hidden={(errorText || "").trim() == "" }
            style={{ width: "100%", color: clr }}
        >
            {errorText}
        </div>
    );
}

export default ErrorLine;
